export default {
	EXTERNAL_SLIDES_UID: '928f8012a8a770a72a85dfa1aab06e28',
	FLOCABULARY_UID: '9a6e23d4dd670ea2b5b819a39e',
}
